module.exports = __webpack_public_path__ + "img/direct-inbox.1c39674f.svg";